import * as ActionTypes from './actionTypes';
import * as MessageActions from '../../common/messageBox/actions/actions';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';
import {printLocationLabels} from '../../common/util/print';

export const getWarehouseLocationsUsage = () => apiActionCreator({
  'endpoint': '/warehouses/CPD/locations/usage',
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_LOCATIONS_USAGE,
    ActionTypes.GOTTEN_LOCATIONS_USAGE,
    [
      ActionTypes.GOTTEN_LOCATIONS_USAGE_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const getFreeWarehouseLocations = (warehouse) => apiActionCreator({
  'endpoint': `/warehouses/${warehouse}/freeLocations`,
  'authenticated': true,
  'types': [
    ActionTypes.GETTING_FREE_LOCATIONS,
    {
      'type': ActionTypes.GOTTEN_FREE_LOCATIONS,
      'payload': warehouse,
    },
    [
      ActionTypes.GOTTEN_FREE_LOCATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'GET',
});

export const deleteWarehouseLocations = (warehouse, locations) => apiActionCreator({
  'endpoint': `/warehouses/locations?warehouse=${warehouse}`,
  'authenticated': true,
  'types': [
    ActionTypes.DELETING_WAREHOUSE_LOCATIONS,
    [
      ActionTypes.DELETED_WAREHOUSE_LOCATIONS,
      MessageActions.addMessageBoxInfo('Ubicaciones eliminadas satisfactoriamente'),
    ],
    [
      ActionTypes.DELETED_WAREHOUSE_LOCATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'DELETE',
  'contentType': 'application/json',
  'data': {locations},
});

export const releaseWarehouseLocations = (warehouse, locations) => apiActionCreator({
  'endpoint': `/warehouses/locations?warehouse=${warehouse}`,
  'authenticated': true,
  'types': [
    ActionTypes.RELEASING_WAREHOUSE_LOCATIONS,
    [
      ActionTypes.RELEASED_WAREHOUSE_LOCATIONS,
      MessageActions.addMessageBoxInfo('Ubicaciones liberadas satisfactoriamente'),
    ],
    [
      ActionTypes.RELEASED_WAREHOUSE_LOCATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': {locations},
});

export const setAvailableWarehouseLocations = (warehouse, locations, available) => apiActionCreator({
  'endpoint': `/warehouses/locations?warehouse=${warehouse}&available=${available}`,
  'authenticated': true,
  'types': [
    ActionTypes.SETTING_AVAILABLE_WAREHOUSE_LOCATIONS,
    [
      ActionTypes.SET_AVAILABLE_WAREHOUSE_LOCATIONS,
      MessageActions.addMessageBoxInfo(
        `Ubicaciones actualizadas como ${available === 'S' ? 'Disponibles' : 'No Disponibles'}`
      ),
    ],
    [
      ActionTypes.SET_AVAILABLE_WAREHOUSE_LOCATIONS_FAILED,
      (error) => buildErrorMessage(error),
    ],
  ],
  'microservice': 'part',
  'method': 'PUT',
  'contentType': 'application/json',
  'data': {locations},
});

export const printWarehouseLocationsLabels = (locations) => {
  printLocationLabels(locations);
  return {'type': ActionTypes.PRINT_WAREHOUSE_LOCATIONS_LABELS};
};
